import type { JSX } from 'react';
import type { OsasRequestAdditionalExaminationData } from '@common/validation/customControls/osas/osasAdditionalExaminationSchema';
import { getOsasSleepRecorderText } from '@common/utils/getOsasSleepRecorderTypeText';
import { FormParagraphFormGroup } from '@frontend/components/fields/FormParagraphField';
import { getSelectedLanguage } from '@frontend/translate';
import { useProcessActivityReadContext } from '@frontend/utils/hooks/useProcessActivityContext';

export function OsasRequestAdditionalExaminationRead(): JSX.Element {
    const { processActivity } = useProcessActivityReadContext<OsasRequestAdditionalExaminationData>();
    const translate = getSelectedLanguage();
    const { customControlData } = processActivity;

    return (
        <>
            <FormParagraphFormGroup label={translate.osas.sleepRecorderType}>
                {customControlData.sleepRecorderType
                    ? getOsasSleepRecorderText(customControlData.sleepRecorderType)
                    : ''}
            </FormParagraphFormGroup>
            <FormParagraphFormGroup label={translate.osas.reasonChanged}>
                {customControlData.reasonChanged}
            </FormParagraphFormGroup>
        </>
    );
}
